import { render } from "./MsButton.vue?vue&type=template&id=63cf81c4&scoped=true"
import script from "./MsButton.vue?vue&type=script&lang=js"
export * from "./MsButton.vue?vue&type=script&lang=js"

import "./MsButton.vue?vue&type=style&index=0&id=63cf81c4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63cf81c4"]])

export default __exports__